import {FormioBase} from "./formiobase";

export class DataGrid extends FormioBase {
  public inputType = "datagrid";
  public title = "Nested block";
  public icon = "fas fa-th";
  public shouldBeRenderedByFormio = false;
  public schema: any = {
    title: "Nested block",
    components: [{
      input: true,
      tree: true,
      components: [],
      tableView: true,
      label: "Nested block",
      key: undefined,
      protected: false,
      persistent: true,
      clearOnHide: true,
      type: "datagrid",
      inputType: "datagrid",
      addAnotherPosition: "bottom",
      tags: [],
      enableRowGroups: true,
      validate: {
        maxLength: 10,
      },
      customClass: "ds-datagrid",
    }],
  };
}
